import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {dataRegister} from "../../services/dataRegister";
import {langRegister} from "../../services/langRegister";
import {userRegister} from "../../services/userRegister";
import {tokenRegister} from "../../services/tokenRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import LanguageButton from "../language-button/component";
import ErrorHandler from "../error-handler/component";
import {agentRegister} from "../../services/agentRegister";
import ReactGA from "react-ga";
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";

class UserInsights extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isLoading: true,
            isLoadingCampaigns: true,
            data: {},
            facebook_feed_status: false,
            google_feed_status: false,
            tiktok_feed_status: false,
            snapchat_feed_status: false,
            campaigns_active: 0,
            campaigns_drafts: 0,
            campaigns_history: 0,
            campaigns_archived: 0,
            campaigns_archived_all: 0,
            campaigns_archived_drafts: 0
        };
    };

    componentWillMount() {
        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/user/insights');
            ReactGA4.send({ hitType: "pageview", page: "/user/insights" });
        }
        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }
        this._updateData();
        this._updateUser();
    }

    _updateData(){
        dataRegister.getInsights(salesChannelRegister.get('market')).then((response) => {
            this.setState({isLoading: true, data: response}, () => {
                dataRegister.account(salesChannelRegister.get('market')).then((response) => {
                    this.setState({
                        facebook_feed_status: response.feed_pref.facebook_remarketing.status ? response.feed_pref.facebook_remarketing.status : this.state.facebook_feed_status,
                        google_feed_status: response.feed_pref.google_remarketing.status ? response.feed_pref.google_remarketing.status : this.state.google_feed_status,
                        tiktok_feed_status: response.feed_pref.tiktok_remarketing.status ? response.feed_pref.tiktok_remarketing.status : this.state.tiktok_feed_status,
                        snapchat_feed_status: response.feed_pref.snapchat_remarketing.status ? response.feed_pref.snapchat_remarketing.status : this.state.snapchat_feed_status,
                        isLoading: false
                    }, () => {
                        dataRegister.getCampaignsCount(salesChannelRegister.get('market')).then((response) => {

                            console.log(response);

                            let AWAITING_PAYMENT = response.AWAITING_PAYMENT ? response.AWAITING_PAYMENT : 0;
                            let SETUP_CBM = response.SETUP_CBM ? response.SETUP_CBM : 0;
                            let RUNNING = response.RUNNING ? response.RUNNING : 0;
                            let AUTO_BILL = response.AUTO_BILL ? response.AUTO_BILL : 0;
                            let READY = response.READY ? response.READY : 0;
                            let ENDED = response.ENDED ? response.ENDED : 0;
                            let ENDED_RENEW = response.ENDED_RENEW ? response.ENDED_RENEW : 0;
                            let TERMINATED = response.TERMINATED ? response.TERMINATED : 0;
                            let TERMINATED_ENDED = response.TERMINATED_ENDED ? response.TERMINATED_ENDED : 0;
                            let TERMINATED_RENEW = response.TERMINATED_RENEW ? response.TERMINATED_RENEW : 0;
                            let ARCHIVED = response.ARCHIVED ? response.ARCHIVED : 0;
                            let DISAPPROVED = response.DISAPPROVED ? response.DISAPPROVED : 0;
                            let ARCHIVED_DISAPPROVED = response.ARCHIVED_DISAPPROVED ? response.ARCHIVED_DISAPPROVED : 0;
                            let RELEASE = response.RELEASE ? response.RELEASE : 0;
                            let DRAFT = response.DRAFT ? response.DRAFT : 0;
                            let ARCHIVED_DRAFT = response.ARCHIVED_DRAFT ? response.ARCHIVED_DRAFT : 0;

                            this.setState({
                                campaigns_active: AWAITING_PAYMENT + RUNNING + AUTO_BILL + READY + SETUP_CBM + DISAPPROVED + RELEASE,
                                campaigns_drafts:  DRAFT,
                                campaigns_history: ENDED + ENDED_RENEW + TERMINATED_ENDED + TERMINATED + TERMINATED_RENEW,
                                campaigns_archived: ARCHIVED + ARCHIVED_DISAPPROVED,
                                campaigns_archived_all: ARCHIVED + ARCHIVED_DISAPPROVED + ARCHIVED_DRAFT,
                                campaigns_archived_drafts: ARCHIVED_DRAFT,
                                isLoading: false
                            });

                        }, (error) => {
                            this.setState({isLoading: false, error: true});
                        });
                    });
                }, (error) => {
                    this.setState({isLoading: false, error: true})
                });
            });
        }, (error) => {
            this.setState({isLoading: false, error: true});
        });
    }

    _updateUser() {
        let user = userRegister.get();
        if(user.socialData){
            this.setState({
                settlements: user.socialData.settlements? user.socialData.settlements : false,
                feeds: user.socialData.feeds ? user.socialData.feeds : false,
                branding: user.socialData.branding ? user.socialData.branding : false,
                crm: user.socialData.crm ? user.socialData.crm : false
            });
        }
    }

    _signOut(){
        userRegister.remove();
        agentRegister.remove();
        tokenRegister.remove();
        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() +"/login");
    }

    _renderRenew(){
        if(this.state.data.renew > 0){
            return Math.round((this.state.data.renew / this.state.data.active) * 100);
        }else{
            return 0
        }
    }

    _renderFeedsTotal(){
        let facebook_status = this.state.facebook_feed_status ? 1 : 0;
        let google_status = this.state.google_feed_status ? 1 : 0;
        let tiktok_status = this.state.tiktok_feed_status ? 1 : 0;
        let snapchat_status = this.state.snapchat_feed_status ? 1 : 0;

        return facebook_status + google_status + tiktok_status + snapchat_status;

        //Old
        /*
        if (this.state.facebook_feed_status && this.state.google_feed_status) {
            return 2
        } else if (this.state.facebook_feed_status) {
            return 1
        } else if (this.state.google_feed_status) {
            return 1
        } else {
            return 0
        }
        */
    }

    _renderTimeSavedSetup() {
        let learning_factor = 123;
        let base_factor = 36;

        if (this.state.branding) {
            base_factor = base_factor + 27;
        }
        if (this.state.crm) {
            base_factor = base_factor + 341;
        }
        if (this.state.feeds) {
            base_factor = base_factor + (this._renderFeedsTotal() * 116);
        }

        return learning_factor + base_factor;
    }

    _renderTimeSavedCampaigns() {

        let active_saved = 0;
        let active_factor = 14;
        let awaiting_payment_saved = 0;
        let awaiting_payment_factor = 8;
        let ended_saved = 0;
        let ended_factor = 14;
        let archived_saved = 0;
        let archived_factor = 8;

        if (this.state.data) {
            active_saved = this.state.data.active * active_factor;
            awaiting_payment_saved = this.state.data.awaiting_payment * awaiting_payment_factor;
            ended_saved = this.state.data.ended * ended_factor;
            //archived_saved = this.state.campaigns_archived * archived_factor;
        }

        return active_saved + awaiting_payment_saved + ended_saved + archived_saved;
    }

    _renderTimeSavedFeeds() {

        let active_saved = 0;
        let active_factor = 27;
        let draft_factor = 120;
        let total_feeds = this._renderFeedsTotal();
        let drafts_all = this.state.campaigns_drafts + this.state.campaigns_archived_drafts;

        if (this.state.data) {
            active_saved = Math.floor(total_feeds * (active_factor + (((this.state.campaigns_drafts + this.state.campaigns_archived_drafts) * draft_factor) / 60)) * (total_feeds > 1 ? 0.65 : 1) );
        }

        return active_saved;
    }

    _renderLockin(){
        if(this.state.data.lock_in > 0){
            return Math.round((this.state.data.lock_in / this.state.data.active) * 100);
        }else{
            return 0
        }
    }

    _renderGauge(){
        let steps = {
            "1": {
                min: 1,
                max: 25
            },
            "2": {
                min: 25,
                max: 50
            },
            "3": {
                min: 50,
                max: 75
            },
            "4": {
                min: 75,
                max: 100
            },
            "5": {
                min: 100,
                max: 125
            },
            "6": {
                min: 125,
                max: 150
            },
            "7": {
                min: 150,
                max: 175
            },
            "8": {
                min: 175,
                max: 200
            }
        };
        if(this.state.data.average_performance > 200){
            return (
                <img className={Styles.containerInnerItemInnerMeterBackgroundContainerLine} src={require("../../assets/images/meter/ab_gauge_8.png")}/>
            )
        }else{
            for(var key in steps){
                if(steps[key].min < this.state.data.average_performance && steps[key].max > this.state.data.average_performance){
                    return(
                        <img className={Styles.containerInnerItemInnerMeterBackgroundContainerLine} src={require("../../assets/images/meter/ab_gauge_"+key+".png")}/>
                    )
                }
            }
        }
    }

    _renderText(item) {
        return langRegister.get("user-insights", item);
    }

    _renderNumber(number){
        return Math.round(number);
    }

    render() {
        return (
            <div>
                <div className={Styles.contentHeader}>
                    <div className={Styles.contentHeaderSearch}>

                    </div>
                    <LanguageButton props={this.props}/>
                    <div onClick={() => this._signOut()} className={Styles.contentHeaderButton}>
                        {this._renderText("item_1")}
                    </div>
                </div>
                <div className={Styles.container}>
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div className={Styles.containerInner}>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_2")}<br/>
                                        {this._renderText("item_3")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValue, Styles.containerInnerItemInnerValueGreen)}>
                                        {this.state.data.active}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={cx(Styles.containerInnerItemInnerTitle, Styles.containerInnerItemInnerTitleMeter)}>
                                        {this._renderText("item_4")}<br/>
                                        {this._renderText("item_5")}
                                    </div>
                                    <div className={Styles.containerInnerItemInnerMeterBackgroundContainer}>
                                        {
                                            salesChannelRegister.get('name') === "propertybooster" &&
                                            <img className={Styles.containerInnerItemInnerMeterBackgroundContainerBg} src={require("../../assets/images/meter/ab_gauge_bg.png")}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === "boostabostad" &&
                                            <img className={Styles.containerInnerItemInnerMeterBackgroundContainerBg} src={require("../../assets/images/BB_gauge_bg.png")}/>
                                        }
                                        {
                                            salesChannelRegister.get('name') === "yieldlock" &&
                                            <img className={Styles.containerInnerItemInnerMeterBackgroundContainerBg} src={require("../../assets/images/YL_gauge_bg.png")}/>
                                        }
                                        {
                                            this._renderGauge()
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_6")}<br/>
                                        {this._renderText("item_7")}
                                    </div>
                                    <div style={salesChannelRegister.get('name')==='yieldlock'?{color: '#E65032'}:{}}  className={cx(Styles.containerInnerItemInnerValue, Styles.containerInnerItemInnerValueRed)}>
                                        {this.state.data.awaiting_payment}
                                    </div>
                                </div>
                            </div>

                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_8")}<br/>
                                        {this._renderText("item_9")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValue, Styles.containerInnerItemInnerValueGreenFade)}>
                                        {this._renderRenew()}<span className={Styles.containerInnerItemInnerValuePercent}>%</span>
                                    </div>
                                </div>
                            </div>

                            {
                                this.state.feeds &&
                                <div className={Styles.containerInnerItem}>
                                    <div className={Styles.containerInnerItemInner}>
                                        <div className={Styles.containerInnerItemInnerTitle}>
                                            {this._renderText("item_17")}<br/>
                                            {this._renderText("item_18")}
                                        </div>
                                        <div className={cx(Styles.containerInnerItemInnerValue, Styles.containerInnerItemInnerValueGreen)}>
                                            {this._renderFeedsTotal()}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_12")}<br/>
                                        {this._renderText("item_13")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValue, Styles.containerInnerItemInnerValueGrey)}>
                                        {this.state.data.ended}
                                    </div>
                                </div>
                            </div>
                        </div>
                    }
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div className={Styles.contentInnerItemHeader}>
                            <div className={Styles.contentInnerItemHeaderTitle}>
                                {this._renderText("item_19")}
                            </div>
                        </div>
                    }
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div className={Styles.containerInner}>
                            <div className={Styles.containerInnerItem}>
                                <div style={this.state.feeds && this.state.data.allLeads && this.state.data.allLeads["2"] ? {marginTop: '40px'} : {}} className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {
                                            this.state.feeds && this.state.data.allLeads && this.state.data.allLeads["2"] &&
                                            salesChannelRegister.get('name') === "propertybooster" &&
                                            <img className={Styles.containerInnerItemInnerTitleAuto} src={require("../../assets/images/auto_icon_pb.svg")}/>
                                        }
                                        {
                                            this.state.feeds && this.state.data.allLeads && this.state.data.allLeads["2"] &&
                                            salesChannelRegister.get('name') === "boostabostad" &&
                                            <img className={Styles.containerInnerItemInnerTitleAuto} src={require("../../assets/images/auto_icon_bb.svg")}/>
                                        }
                                        {
                                            this.state.feeds && this.state.data.allLeads && this.state.data.allLeads["2"] &&
                                            salesChannelRegister.get('name') === "yieldlock" &&
                                            <img className={Styles.containerInnerItemInnerTitleAuto} src={require("../../assets/images/auto_icon_yl.svg")}/>
                                        }
                                        {this._renderText("item_20")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                        {this.state.data.allLeads && this.state.data.allLeads["2"] ? this.state.data.allLeads["2"] : 0}
                                    </div>
                                    {
                                        this.state.feeds && this.state.data.allLeads && this.state.data.allLeads["2"] &&
                                    <div className={Styles.containerInnerItemInnerSubTitle}>
                                        {this._renderText("item_51")}
                                    </div>
                                    }
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_21")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                        {this.state.data.allLeads && this.state.data.allLeads["4"] ? this.state.data.allLeads["4"] : 0}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_22")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                        {this.state.data.allLeads && this.state.data.allLeads["1"] ? this.state.data.allLeads["1"] : 0}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_54")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                        {this.state.data.allLeads && this.state.data.allLeads["5"] ? this.state.data.allLeads["5"] : 0}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_47")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                        {this.state.data.allLeadsByEvent && this.state.data.allLeadsByEvent["2"] ? this.state.data.allLeadsByEvent["2"] : 0}
                                    </div>
                                    <div className={Styles.containerInnerItemInnerSubTitle}>
                                        {this._renderText("item_50")}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_48")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                        {this.state.data.allLeadsByEvent && this.state.data.allLeadsByEvent["3"] ? this.state.data.allLeadsByEvent["3"] : 0}
                                    </div>
                                    <div className={Styles.containerInnerItemInnerSubTitle}>
                                        {this._renderText("item_50")}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_49")}
                                    </div>
                                    <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                        {this.state.data.allLeadsByEvent && this.state.data.allLeadsByEvent["4"] ? this.state.data.allLeadsByEvent["4"] : 0}
                                    </div>
                                    <div className={Styles.containerInnerItemInnerSubTitle}>
                                        {this._renderText("item_50")}
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItemEmpty}>

                            </div>
                        </div>
                    }
                    {
                        !this.state.isLoading && !this.state.error && this.state.settlements &&
                        <div className={Styles.contentInnerItemHeader}>
                            <div className={Styles.contentInnerItemHeaderTitle}>
                                {this._renderText("item_16")}
                            </div>
                        </div>
                    }
                    {
                        !this.state.isLoading && !this.state.error && this.state.settlements &&
                        <div className={Styles.containerInner}>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_14")}
                                    </div>
                                    <div
                                        className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                        {this._renderNumber(this.state.data.currentMonthSale)}<span
                                        className={Styles.containerInnerItemInnerValueCurrency}>{salesChannelRegister.get("currency")}</span>
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItem}>
                                <div className={Styles.containerInnerItemInner}>
                                    <div className={Styles.containerInnerItemInnerTitle}>
                                        {this._renderText("item_15")}
                                    </div>
                                    <div
                                        className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                        {this._renderNumber(this.state.data.lastMonthSale)}<span
                                        className={Styles.containerInnerItemInnerValueCurrency}>{salesChannelRegister.get("currency")}</span>
                                    </div>
                                </div>
                            </div>
                            <div className={Styles.containerInnerItemEmpty}>

                            </div>
                        </div>
                    }
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div className={Styles.contentInnerItemHeader}>
                            <div className={Styles.contentInnerItemHeaderTitle}>
                                {this._renderText("item_34")}
                            </div>
                        </div>
                    }
                    {
                        !this.state.isLoading && !this.state.error &&
                        <div className={Styles.containerInner}>
                            {
                                <div className={Styles.containerInnerItem}>
                                    <div className={Styles.containerInnerItemInner}>
                                        <div className={Styles.containerInnerItemInnerTitle}>
                                            {this._renderText("item_41")}<br/>
                                            {this._renderText("item_42")}
                                        </div>
                                        <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                            {this._renderTimeSavedSetup()}<span
                                            className={Styles.containerInnerItemInnerValueHours}>{this._renderText("item_36")}</span>
                                        </div>
                                        <div className={Styles.containerInnerItemInnerSubTitle}>
                                            {this._renderText("item_37")}{this._renderText("item_38")}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                <div className={Styles.containerInnerItem}>
                                    <div className={Styles.containerInnerItemInner}>
                                        <div className={Styles.containerInnerItemInnerTitle}>
                                            {this._renderText("item_43")}<br/>
                                            {this._renderText("item_44")}
                                        </div>
                                        <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                            {this._renderTimeSavedCampaigns()}<span
                                            className={Styles.containerInnerItemInnerValueHours}>{this._renderText("item_36")}</span>
                                        </div>
                                        <div className={Styles.containerInnerItemInnerSubTitle}>
                                            {this._renderText("item_37")}{this._renderText("item_45")}
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.branding && this.state.feeds &&
                                <div className={Styles.containerInnerItem}>
                                    <div className={Styles.containerInnerItemInner}>
                                        <div className={Styles.containerInnerItemInnerTitle}>
                                            {this._renderText("item_39")}<br/>
                                            {this._renderText("item_40")}
                                        </div>
                                        <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                            {this._renderTimeSavedFeeds()}<span
                                            className={Styles.containerInnerItemInnerValueHours}>{this._renderText("item_36")}</span>
                                        </div>
                                        <div className={Styles.containerInnerItemInnerSubTitle}>
                                            {this._renderText("item_37")}{this._renderText("item_46")}
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    {
                        !this.state.isLoading && !this.state.error && this.state.branding &&
                        <div className={Styles.contentInnerItemHeader}>
                            <div className={Styles.contentInnerItemHeaderTitle}>
                                {this._renderText("item_31")}
                            </div>
                        </div>
                    }
                    {
                        !this.state.isLoading && !this.state.error && this.state.branding &&
                        <div className={Styles.containerInner}>
                            {
                                <div className={Styles.containerInnerItem}>
                                    <div className={Styles.containerInnerItemInner}>
                                        <div className={Styles.containerInnerItemInnerTitle}>
                                            {
                                                salesChannelRegister.get('name') === "propertybooster" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active.svg")}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === "boostabostad" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active_boostabostad.svg")}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === "yieldlock" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active_yl.svg")}/>
                                            }
                                            {this._renderText("item_23")}<br/>
                                            {this._renderText("item_24")}
                                        </div>
                                        <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                            {this._renderText("item_25")}<span
                                            className={Styles.containerInnerItemInnerValuePercent}>{this._renderText("item_26")}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.crm && this.state.feeds &&
                                <div className={Styles.containerInnerItem}>
                                    <div className={Styles.containerInnerItemInner}>
                                        <div className={Styles.containerInnerItemInnerTitle}>
                                            {
                                                salesChannelRegister.get('name') === "propertybooster" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active.svg")}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === "boostabostad" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active_boostabostad.svg")}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === "yieldlock" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active_yl.svg")}/>
                                            }
                                            {this._renderText("item_29")}<br/>
                                            {this._renderText("item_30")}
                                        </div>
                                        <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                            {this._renderText("item_25")}<span
                                            className={Styles.containerInnerItemInnerValuePercent}>{this._renderText("item_26")}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                <div className={Styles.containerInnerItem}>
                                    <div className={Styles.containerInnerItemInner}>
                                        <div className={Styles.containerInnerItemInnerTitle}>
                                            {
                                                salesChannelRegister.get('name') === "propertybooster" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active.svg")}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === "boostabostad" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active_boostabostad.svg")}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === "yieldlock" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active_yl.svg")}/>
                                            }
                                            {this._renderText("item_27")}<br/>
                                            {this._renderText("item_28")}
                                        </div>
                                        <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                            {this._renderText("item_25")}<span
                                            className={Styles.containerInnerItemInnerValuePercent}>{this._renderText("item_26")}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.feeds &&
                                <div className={Styles.containerInnerItem}>
                                    <div className={Styles.containerInnerItemInner}>
                                        <div className={Styles.containerInnerItemInnerTitle}>
                                            {
                                                this._renderFeedsTotal() > 0 &&
                                                salesChannelRegister.get('name') === "propertybooster" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active.svg")}/>
                                            }
                                            {
                                                this._renderFeedsTotal() > 0 &&
                                                salesChannelRegister.get('name') === "boostabostad" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active_boostabostad.svg")}/>
                                            }
                                            {
                                                this._renderFeedsTotal() > 0 &&
                                                salesChannelRegister.get('name') === "yieldlock" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active_yl.svg")}/>
                                            }
                                            {
                                                this._renderFeedsTotal() === 0 &&
                                                    salesChannelRegister.get('name') === "propertybooster" &&
                                                    <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_deactive.svg")}/>
                                            }
                                            {
                                                this._renderFeedsTotal() === 0 &&
                                                    salesChannelRegister.get('name') === "boostabostad" &&
                                                    <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_deactive.svg")}/>
                                            }
                                            {
                                                this._renderFeedsTotal() === 0 &&
                                                    salesChannelRegister.get('name') === "yieldlock" &&
                                                    <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_deactive_yl.svg")}/>
                                            }
                                            {this._renderText("item_32")}<br/>
                                            {this._renderText("item_33")}
                                        </div>
                                        <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                            {this._renderText("item_25")}<span
                                            className={Styles.containerInnerItemInnerValuePercent}>{this._renderText("item_26")}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                            {
                                this.state.feeds &&
                                <div className={Styles.containerInnerItem}>
                                    <div className={Styles.containerInnerItemInner}>
                                        <div className={Styles.containerInnerItemInnerTitle}>
                                            {
                                                salesChannelRegister.get('name') === "propertybooster" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active.svg")}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === "boostabostad" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active_boostabostad.svg")}/>
                                            }
                                            {
                                                salesChannelRegister.get('name') === "yieldlock" &&
                                                <img className={Styles.containerInnerItemInnerTitleSlider} src={require("../../assets/images/slider_active_yl.svg")}/>
                                            }
                                            {this._renderText("item_52")}<br/>
                                            {this._renderText("item_53")}
                                        </div>
                                        <div className={cx(Styles.containerInnerItemInnerValueSmall, Styles.containerInnerItemInnerValueGreen)}>
                                            {this._renderText("item_25")}<span
                                            className={Styles.containerInnerItemInnerValuePercent}>{this._renderText("item_26")}</span>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                    }
                    {
                        this.state.isLoading &&
                        <div className={Styles.loader}>
                            <BeatLoader size={30} color={'var(--first-color)'} loading={true}/>
                        </div>
                    }
                    {
                        !this.state.isLoading && this.state.error &&
                        <div className={Styles.loader}>
                            <ErrorHandler/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default UserInsights;


// WEBPACK FOOTER //
// ./src/components/user-insights/component.js